export default "__VITE_ASSET__9e5cd694__"